import { useState } from "react";
import { EyeIcon } from "../assests/svg/SvgIcons";
import { forgot_Password, log_in_by_email } from "../api/serverWrapper";
import { useNavigate } from "react-router-dom";
import { routeUserAfterLogin } from "../utils/loginNavigation";
import { useAccountStatusGate } from "../hooks/useAccountStatusGate";
import AccountStatusModals from "../hooks/AccountStatusModals";

const EmailLogin = ({ setEmailMode, loginType }) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const [showForgot, setShowForgot] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const navigate = useNavigate();

  // Single source of truth for the deleted/disabled account flow —
  // owns its own popup state + reactivate handler, nothing duplicated here.
  const {
    accountDeletedPopup,
    setAccountDeletedPopup,
    accountDisabledPopup,
    setAccountDisabledPopup,
    isEnabling,
    checkAccountStatus,
    handleReactivateAccount,
  } = useAccountStatusGate();

  const login = async () => {
    if (loading) return;
    let newErrors = {};

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(email)) {
      newErrors.email = "Enter valid email address";
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    const data = {
      EMail: email,
      Password: password,
    };
    setLoading(true);
    try {
      const resp = await log_in_by_email(data);
      console.log(resp);

      if (resp.success) {
        const user = resp.data;
        if (checkAccountStatus(user)) return;
        await routeUserAfterLogin(user, navigate, { email, replace: true });
      } else {
        alert(resp.message || "Login failed");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (!resetEmail) {
      alert("Enter email");
      return;
    }

    setResetLoading(true);
    try {
      const res = await forgot_Password({ EMail: resetEmail });

      if (res.success) {
        alert("New password sent to your email");
        setShowForgot(false);
        setResetEmail("");
      } else {
        alert(res.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
      alert("Error sending reset email");
    } finally {
      setResetLoading(false);
    }
  };

  return (
    <div className="email-card">
      <h2>Email Login</h2>

      <form
        onSubmit={(e) => {
          e.preventDefault(); // prevent page reload
          login();
        }}
      >
        <div className="email-field">
          <label>Email ID</label>
          <input
            type="email"
            placeholder="Email ID"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        {errors.email && <span className="error-text">{errors.email}</span>}

        <div className="email-field password-wrapper">
          <label>Password</label>

          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {/* 👁 Eye Icon */}
          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "🙈" : EyeIcon}
          </span>
        </div>
        {errors.password && (
          <span className="error-text">{errors.password}</span>
        )}
        <div className="d-flex justify-content-between">
          <span
            className="error-text"
            style={{ cursor: "pointer" }}
            onClick={() => setShowForgot(true)}
          >
            Forgot Password?
          </span>
        </div>

        <button className="email-submit mt-4" type="submit">
          {loading ? <span className="spinner"></span> : <> Login →</>}
        </button>
      </form>

      <div className="email-switch">
        Not registered with us?{" "}
        <span onClick={() => setEmailMode("signup")}>Signup →</span>
      </div>

      {showForgot && (
        <div className="forgot-popup">
          <div className="forgot-card">
            <h3>Reset Password</h3>

            <input
              type="email"
              placeholder="Enter your email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
            />

            <div className="forgot-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowForgot(false)}
              >
                Cancel
              </button>

              <button
                className="confirm-btn"
                onClick={handleResetPassword}
                disabled={resetLoading}
              >
                {resetLoading ? "Sending..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}

      <AccountStatusModals
        accountDeletedPopup={accountDeletedPopup}
        setAccountDeletedPopup={setAccountDeletedPopup}
        accountDisabledPopup={accountDisabledPopup}
        setAccountDisabledPopup={setAccountDisabledPopup}
        isEnabling={isEnabling}
        handleReactivateAccount={handleReactivateAccount}
      />
    </div>
  );
};

export default EmailLogin;